import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import PageHeader from "../pageheader/PageHeader";
import ManuOperation from "./navOperationRoom/ManuOperation";
import Input from "../material/input/Input";
import Button from "../material/button/Button";
import Pagination from "../pagination/Pagination";

import styles from "./ManageUsers.module.css";
import plusSmall from "../../asset/icon/plus-small.svg";
import searchIcon from "../../asset/icon/search.svg";
import loadCircle from "../../asset/icon/loadCircle.svg";

import * as labPersonalApi from "../../service/labPersonalApi";
import { RedirectCode400 } from "../RedirectCode400";
import { CurrentUserContext } from "../../App";
import ModalTransferAdminRole from "../material/modal/ModalTransferAdminRole";
import DialogTailwindConfirm from "../DialogTailwindConfirm";

import DataTable from "react-data-table-component";
const customStyles = {
  rows: {
    style: {
      // override the row height
      "&:nth-child(even)": {
        background: "#effff4",
      },
      "&:not(:last-of-type)": {
        borderBottomWidth: "none",
      },
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      display: "flex",
      justifyContent: "center",
      background: "#B8DFC7",
      fontSize: 18,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      display: "flex",
      justifyContent: "center",
      borber: "1px solid #B8DFC7",
    },
  },
};

export default function ManageUsersRequest() {
  const [toggle, setToggle] = useState("listAllStaff");

  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [Actionstate, setActionState] = useState("");
  const [openModal, setOpenModal] = useState(false);

  //รายชื่อเจ้าหน้าที่ทั้งหมด
  const [userDataList, setUserDataList] = useState([]);
  const [date, setDate] = useState("");
  const [inputvalue, setInputValue] = useState("");
  const [saveData, setSaveData] = useState([]);
  const [numberstaff, setNumberStaff] = useState("");

  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  //รายชื่อผู้ขอย้ายเข้าห้องปฏิบัติการ
  const [userTransferList, setUserTransferList] = useState([]);
  const [numberTransfer, setNumberTransfer] = useState("");

  const [inputvalueTransfer, setInputValueTransfer] = useState("");
  const [saveDataTranser, setSaveDataTranser] = useState([]);

  //ตั้งค่า Dialog
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [isDialogOpenApproved, setIsDialogOpenApproved] = useState(false);
  const [selectedDataApproved, setSelectedDataApproved] = useState(null);

  useEffect(() => {
    setDate(moment().add(543, "years").format("DD MMMM YYYY"));
  }, []);

  useEffect(() => {
    getTransferAccount();
  }, []);

  useEffect(() => {
    getUserDataList();
  }, [Actionstate]);

  useEffect(() => {
    getUserDataList();
  }, [page]);

  const getUserDataList = async () => {
    setLoading(true);
    let res = await labPersonalApi.getUserDataList(page);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setUserDataList(res["data"]["user_data_list"]);
        setSaveData(res["data"]["user_data_list"]);

        setTotalPage(Math.ceil(res["data"]["amount"] / 10));

        let numberOfStaff = res["data"]["user_data_list"].length;
        setNumberStaff(numberOfStaff);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
        setNumberStaff(0);
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
        setNumberStaff(0);
      }
    } else {
      setIsMessage({ type: "warning", data: res["data"]["message_th"] });
    }
  };

  const setApproveUser = async (uid, approve) => {
    let res = await labPersonalApi.setApprove(uid, approve);
    setActionState(res);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: res["data"]["message_th"] });
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const setEnableUser = async (uid, enable) => {
    let res = await labPersonalApi.setEnable(uid, enable);
    setActionState(res);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: res["data"]["message_th"] });
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  //เปิด Dialog Approved
  const handleConfirmApproved = async (confirmed, data) => {
    setIsDialogOpenApproved(false);
    // console.log(data)
    if (confirmed && data) {
      setApproveUser(data.uid, data.isAuthDisabled);
    }
  };
  const openDialogApproved = (rowData) => {
    setSelectedDataApproved(rowData);
    setIsDialogOpenApproved(true);
  };

  const handleActiveApprove = (uid, approve, fname) => {
    if (approve === false) {
      return (
        // <button className={styles.button__false__table} onClick={() => { setApproveUser(uid, !approve) }} >
        //     <div className={styles.text__status__table}>ยังไม่อนุมัติ</div>
        // </button>

        <button
          className={styles.button__false__table}
          onClick={() =>
            openDialogApproved({
              message: `กรุณายืนยันการทำรายการ คุณกำลัง อนุมัติ ผู้ใช้งาน ${fname} ใช่หรือไม่ `,
              uid: uid,
              isAuthDisabled: !approve,
            })
          }
        >
          <div className={styles.text__status__table}>ยังไม่อนุมัติ</div>
        </button>
      );
    } else if (approve === true) {
      return (
        <div style={{ color: "#64BD86", fontSize: "14px" }}>อนุมัติแล้ว</div>
        // <button className={styles.button__true__table} onClick={() => { setApproveUser(uid, !approve) }} >
        //     <div className={styles.text__status__table}>อนุญาตแล้ว</div>
        // </button>
      );
    } else {
      setIsMessage({ type: "error", data: "not working" });
    }
  };

  // ฟังก์ชันเปิด dialog พร้อมบันทึกข้อมูล row ที่ต้องการ
  const openDialog = (rowData) => {
    setSelectedData(rowData);
    setIsDialogOpen(true);
  };

  //เปิด Dialog
  const handleConfirm = async (confirmed, data) => {
    setIsDialogOpen(false);
    // console.log(data)
    if (confirmed && data) {
      setEnableUser(data.uid, data.isAuthDisabled);
    }
  };

  const handleActiveEnable = (uid, enable, fname) => {
    if (enable === false) {
      return (
        <button
          className={styles.button__false__table}
          onClick={() => {
            setEnableUser(uid, !enable);
          }}
        >
          <div className={styles.text__status__table}>Inactive</div>
        </button>
      );
    } else if (enable === true) {
      return (
        <button
          className={styles.button__true__table}
          onClick={() =>
            openDialog({
              message: `กรุณายืนยันการทำรายการ คุณกำลัง Inactive ผู้ใช้งาน ${fname} ใช่หรือไม่ `,
              uid: uid,
              isAuthDisabled: !enable,
            })
          }
        >
          <div className={styles.text__status__table}>Active</div>
        </button>
        // <button className={styles.button__true__table} onClick={() => { setEnableUser(uid, !enable) }}>
        //     <div className={styles.text__status__table}>Active</div>
        // </button>
      );
    } else {
      setIsMessage({ type: "error", data: "not working" });
    }
  };

  const onclickAddData = () => {
    navigate("/addOperationStaff");
  };

  const handleChangeSearch = (value) => {
    setInputValue(value);
  };

  const handleClickSearch = () => {
    // console.log(userDataList);
    if (inputvalue !== "") {
      const filterData = userDataList.filter((item) => {
        return item["pid"]?.toLowerCase().includes(inputvalue?.toLowerCase());
      });
      setUserDataList(filterData);
    } else {
      setUserDataList(saveData);
    }
  };

  const clickFile = (url) => {
    window.open(url);
  };

  const getTransferAccount = async () => {
    setLoading(true);
    let res = await labPersonalApi.getTransferAccount();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setUserTransferList(res["data"]["transfer_account_list"]);
        let numberOfTransfer = res["data"]["transfer_account_list"]?.length;
        setNumberTransfer(numberOfTransfer);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
        setNumberTransfer(0);
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
        setNumberTransfer(0);
      }
    } else {
      setIsMessage({ type: "warning", data: res["data"]["message_th"] });
    }
  };

  const actionTransferAccount = async (transfer_id, status) => {
    let res = await labPersonalApi.actionTransferAccount(transfer_id, status);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "สำเร็จ" });
        getTransferAccount();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      }
    } else {
      setIsMessage({ type: "warning", data: res["data"]["message_th"] });
    }
  };

  const handleChangeSearchTransfer = (value) => {
    setInputValueTransfer(value);
  };

  const handleClickSearchTransfer = () => {
    if (inputvalueTransfer !== "") {
      const filterDataTransfer = userTransferList.filter((item) => {
        return item["pid"]
          ?.toLowerCase()
          .includes(inputvalueTransfer?.toLowerCase());
      });
      setUserTransferList(filterDataTransfer);
    } else {
      setUserTransferList(saveDataTranser);
    }
  };

  const transfer = (transfer_id) => {
    return (
      <div style={{ display: "flex", gridGap: "2%", justifyContent: "center" }}>
        <Button
          style={{ width: "40%" }}
          onClick={() => {
            actionTransferAccount(transfer_id, "ACCEPT");
          }}
        >
          อนุมัติ
        </Button>
        <Button
          style={{ width: "40%", background: "#DA2C4B", border: "none" }}
          onClick={() => {
            actionTransferAccount(transfer_id, "REJECT");
          }}
        >
          ไม่อนุมัติ
        </Button>
      </div>
    );
  };

  const onclickTransferRole = () => {
    setOpenModal(true);
  };

  const columnsListAllStaff = [
    {
      name: "ชื่อ",
      selector: (i) => <div>{i["fname"]}</div>,
      wrap: true,
    },
    {
      name: "นามสกุล",
      selector: (i) => <div>{i["lname"]}</div>,
      wrap: true,
    },
    {
      name: "เบอร์โทร",
      selector: (i) => <div>{i["phone_number"]}</div>,
      minWidth: "130px",
    },
    {
      name: "หน้าที่",
      selector: (i) => <div>{i["position"]}</div>,
      wrap: true,
    },
    {
      name: "เลขใบประกอบวิชาชีพ",
      selector: (i) => <div>{i["license_number"]}</div>,
      minWidth: "200px",
      wrap: true,
    },
    {
      name: "ไฟล์คำร้อง",
      selector: (i) => (
        <div>
          {i["attachment_file"] ? (
            <button
              className={styles.button_file}
              onClick={() => {
                clickFile(i["attachment_file"]["url"]);
              }}
            >
              ดูไฟล์
            </button>
          ) : (
            <button className={styles.button_file_not}>ไม่มีไฟล์คำร้อง</button>
          )}
        </div>
      ),
      minWidth: "160px",
    },
    {
      name: "อนุมัติผู้ใช้งาน",
      selector: (i) => (
        <div>
          {handleActiveApprove(i["uid"], i["auth"]["approve"], i["fname"])}
        </div>
      ),
      minWidth: "150px",
    },
    {
      name: "สถานะผู้ใช้งาน",
      selector: (i) => (
        <div>
          {handleActiveEnable(i["uid"], i["auth"]["enable"], i["fname"])}
        </div>
      ),
      minWidth: "150px",
    },
  ];
  const columnsListTransfer = [
    {
      name: "ชื่อ",
      selector: (i) => <div>{i["user"]["fname"]}</div>,
      wrap: true,
    },
    {
      name: "นามสกุล",
      selector: (i) => <div>{i["user"]["lname"]}</div>,
      wrap: true,
    },
    {
      name: "เบอร์โทร",
      selector: (i) => <div>{i["user"]["phone_number"]}</div>,
      minWidth: "130px",
    },
    {
      name: "ย้ายมาจาก",
      selector: (i) => <div>{i["user"]["laboratory"]["laboratory_name"]}</div>,
      wrap: true,
    },
    {
      name: "อนุมัติการย้าย",
      selector: (i) => <div>{transfer(i["transfer_id"])}</div>,
    },
  ];

  return (
    <div class="bg-[#ffffff] pb-[30px]">
      <div className={styles.blockContent}>
        <div
          className={`text-3xl md:text-[18px] flex font-bold mt-2 mb-4 font-['Prompt-SemiBold']`}
        >
          รายชื่อผู้ขอย้ายเข้าห้องปฏิบัติการ
          <div className={styles.subTitle2}>{`(ข้อมูลวันที่ ${date})`}</div>
        </div>
        <div className={styles.container}>
          <div className={styles.alignData}>
            <div className={styles.alignInput}>
              <div className={styles.Input}>
                <Input
                  disabledLabel={true}
                  placeholder="ค้นหาด้วยเลขบัตรประชาชน"
                  value={inputvalueTransfer}
                  setValue={handleChangeSearchTransfer}
                />
              </div>
              <Button
                style={{ margin: "0px 5%" }}
                onClick={handleClickSearchTransfer}
              >
                <img src={searchIcon} />
                <div style={{ marginLeft: "2%" }}>ค้นหา</div>
              </Button>
            </div>
          </div>

          <div style={{ marginTop: "2%" }}>
            <DataTable
              className="classTable"
              columns={columnsListTransfer}
              data={userTransferList}
              customStyles={customStyles}
              noDataComponent={<div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>}
            />
          </div>
        </div>

        {/* เปิด DialogTailwindConfirm พร้อมส่งข้อมูล row ที่เลือก */}
        {isDialogOpen && selectedData && (
          <DialogTailwindConfirm
            onConfirm={handleConfirm}
            onCancel={handleConfirm}
            data={selectedData}
          />
        )}
        {isDialogOpenApproved && selectedDataApproved && (
          <DialogTailwindConfirm
            onConfirm={handleConfirmApproved}
            onCancel={handleConfirmApproved}
            data={selectedDataApproved}
          />
        )}

        {openModal ? (
          <>
            <ModalTransferAdminRole
              data={userDataList}
              onClose={() => {
                setOpenModal(false);
              }}
            />
          </>
        ) : null}
      </div>
    </div>
  );
}
